import React from 'react'
import { Row, Col } from 'antd'
import SupportHeader from './SupportHeader'
import SupportMainTab from './SupportMainTab'
import { isMobile } from 'react-device-detect'
const Support = () => {
    return (
        <>
            <Row className={!isMobile ? "sec1": ""}>
                <Col span={24}>
                    <SupportHeader />
                    <section>
                        <SupportMainTab />
                    </section>
                </Col>
            </Row>

        </>
    )
}

export default Support
